import React from 'react'
import "./Terms_and_condition.css"
import Cancle_btn from '../common/common_btn/cancle_btn/Cancle_btn';
import Sumbit_btn from '../common/common_btn/submit_btn/Sumbit_btn';
import Policy_banner from '../common/policy_banner/Policy_banner';

function Terms_and_condition() {
    const breadcrumbs = [
        { label: "Home", link: "/", isActive: false },
        { label: "TERMS AND CONDITIONS", link: "", isActive: true },
    ];

    return (
        <>
            <Policy_banner
                breadcrumbs={breadcrumbs}
                headingText="TERMS AND CONDITIONS"
                imgSrc="/assets/images/policy_banner/terms_and_condition/terms_and_condition_banner.png"
            />
            <div className="container">
                <div className="content_holder">
                    <div className="text_holder">
                        <p>
                            Welcome to CAMPUS DEAL . By accessing or using our platform mobile app, you agree to be bound by these Terms and Conditions. Please read them carefully before using our services.
                        </p>
                    </div>
                    <div className="list_holder">
                        <ul>
                            <li>
                                <div className='text_holder'>
                                    <h6>1. Platform Usage</h6>
                                    <p>CAMPUS DEAL is a service discovery and lead-generation platform that connects customers with verified vendors and experts. You may use the platform only for lawful purposes and in compliance with these terms.</p>
                                </div>
                            </li>
                            <li>
                                <div className='text_holder'>
                                    <h6>2. User Registration</h6>
                                    <p>To access certain features, users (customers, vendors, experts) must register with accurate personal or business details. Users are responsible for maintaining the confidentiality of login information.</p>
                                </div>
                            </li>
                            <li>
                                <div className='text_holder'>
                                    <h6>3. Service Listings & Content</h6>
                                    <p>Vendors and experts may list their services on the platform. All information provided must be accurate and up to date. Misleading content or impersonation may result in account suspension.</p>
                                </div>
                            </li>
                            <li>
                                <div className='text_holder'>
                                    <h6>4. Inquiries & Communication</h6>
                                    <p>Users can send inquiries through the app or website. CAMPUS DEAL is not responsible for the completion or quality of the service provided by third-party vendors or experts.</p>
                                </div>
                            </li>
                            <li>
                                <div className='text_holder'>
                                    <h6>5. Verification & Ratings</h6>
                                    <p>CAMPUS DEAL performs basic verification of vendors and experts but does not guarantee the performance or background of service providers. Ratings and reviews are user-generated and monitored for abuse.</p>
                                </div>
                            </li>
                            <li>
                                <div className='text_holder'>
                                    <h6>6. Payments & Subscriptions</h6>
                                    <p>Some services (like expert listings or inquiry access) may require payment or subscription. All payments are processed securely. No refunds will be issued once the service is activated, unless otherwise stated.</p>
                                </div>
                            </li>
                            <li>
                                <div className='text_holder'>
                                    <h6>7. Intellectual Property</h6>
                                    <p>All content, logos, and designs on CAMPUS DEAL are the property of CAMPUS DEAL  Technologies Pvt. Ltd. and cannot be copied or reused without permission.</p>
                                </div>
                            </li>
                            <li>
                                <div className='text_holder'>
                                    <h6>8. Privacy & Data</h6>
                                    <p>We value your privacy. Please refer to our [Privacy Policy] for details on how your information is collected, used, and protected.</p>
                                </div>
                            </li>
                            <li>
                                <div className='text_holder'>
                                    <h6>9. Modifications</h6>
                                    <p>CAMPUS DEAL may update these terms from time to time. Continued use of the platform indicates your acceptance of any changes.</p>
                                </div>
                            </li>
                            <li>
                                <div className='text_holder'>
                                    <h6>10. Contact Us</h6>
                                    <p>For any questions or concerns regarding these Terms & Conditions, contact us at support@campusdeal.in</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div className='btn_holder'>
                        <Cancle_btn btnText="Decline" />
                        <Sumbit_btn btnText="Accept" />
                    </div>
                </div>
            </div>
        </>
    )
}

export default Terms_and_condition;
